import { MetaClass } from '@master/annotation/MetaClass'
import { RawKey } from '@master/annotation/RawKey'
import { Meta } from '@master/model/common/Meta'
import { PolicyClientMeta } from './PolicyClientMeta'

export class ClientPolicyMeta extends Meta {
  @RawKey('_oid')
  oid = ''

  clientOid = ''
  adviserOid = ''
  introducerOid = ''
  introducerPct = ''
  introducerIfam: boolean = undefined
  servicingOid = ''
  servicingPct: number = undefined
  servicingIfam: boolean = undefined
  vestingOid = ''
  vestingPct: number = undefined
  vestingIfam: boolean = undefined
  ownersOid = ''
  ownersName = ''
  ownersNric = ''
  insuredTitle = ''
  insuredName = ''
  insuredNric = ''
  insuredTitleTwo = ''
  insuredNameTwo = ''
  insuredNricTwo = ''
  productOid = ''
  name = ''
  productTypeDetailed = ''
  productCategory = ''
  taggedKyc = ''
  type = ''
  policyNumber = ''
  businessId = ''
  principal = ''
  status = ''
  applicationDate: number = undefined
  opsApprovalDate: number = undefined
  approvedDate: number = undefined
  startDate: number = undefined
  endDate: number = undefined
  bscClawbackStatus = ''
  bscClawbackAmount: number = undefined
  clientRebateStatus = ''
  clientRebateAmount: number = undefined
  clientAiStatus: number = undefined
  productMetadata = ''

  @MetaClass(PolicyClientMeta)
  clientMetadata: PolicyClientMeta = new PolicyClientMeta()

  creationType = ''
  faceToFace: number = undefined
  policyProfileRemarks = ''
  level1ComOid = ''
  level2ComOid = ''
  level3ComOid = ''
  level4ComOid = ''
  level1ComPct: number = undefined
  level2ComPct: number = undefined
  level3ComPct: number = undefined
  level4ComPct: number = undefined
  faceToFaceSpecified = ''
}
